// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPropsContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterPropsContainer component
 */
!(function() {
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');

  var withProps = require('recompose').withProps;
  var setPropTypes = require('recompose').setPropTypes;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;

  var branch = require('recompose').branch;
  var renderComponent = require('recompose').renderComponent;

  var React = require('react');
  var FormGroup = require('share/components/controls/Izenda.FormGroup');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var PropertiesEditorContainer = require('share/components/controls/Izenda.PropertiesEditorContainer');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  var PropertiesEditorUtils = require('share/utils/Izenda.PropertiesEditorUtils');
  var FilterPropertiesSchema = require('../Filter/Izenda.FilterPropertiesSchema');
  var classnames = require('classnames');
  var ToggleViewModePropertyEditor = require('share/components/controls/Izenda.ToggleViewModePropertyEditor');
  var compare = require('share/utils/Izenda.PropsComparison');

  const { isEmpty, getOr, isNil, curry } = require('lodash/fp');

  // show title of group only
  var UNUSED_PROPS_NULL_CONFIG_FILTER = [
    'fields.sourceInfo.fields',
    'fields.filterOperator.fields',
    'fields.filterSettings.fields',
    'fields.filterFormating.fields'
  ];

  var FilterPropsContainer = observer(function(props) {
    var localization = props.localization;

    var configFilter = props.getConfigFilter();
    var configFilterValue = getValue(configFilter.fieldDetails);

    return (
      <section className="form-horizontal field-props-container">
        <div className="field-props-header">
          <div className="title-group">
            <strong className="u_textUppercase u_inlineBlock">
              {localization.getText('COMMON_LABEL_FILTER_PROPERTIES')}
            </strong>
            <ToggleViewModePropertyEditor />
          </div>

          <FormGroup className="report-parts">
            <DropDown
              blankOption
              options={props.getFilterList()}
              valueField={getValue}
              labelField={getLabel}
              onChange={onChangeFilter}
              value={configFilterValue}
            />
          </FormGroup>
        </div>
        <fieldset disabled={isNil(configFilterValue)} className="field-props-content">
          <ScrollBox>
            <FilterDetailsContainer
              alias={props.reportFilter.configField.fieldDetails.alias}
              reportDesignerModel={props.reportDesignerModel}
              fieldStore={props.fieldStore}
              reportFilter={props.reportFilter}
              validation={props.validation}
              querySourceFieldId={configFilter.fieldDetails.querySourceFieldId}
            />
          </ScrollBox>
        </fieldset>
      </section>
    );

    function onChangeFilter(val, item) {
      var args = arguments;
      return props.validation.validate().then(function(isValid) {
        if (isValid) {
          props.setFilterConfig.apply(null, args);
        } else {
          throw new Error('error');
        }
      });
    }

    function getLabel(filter) {
      return filter ? [String.format('[{0}]', filter.position), filter.alias].join(' ') : '';
    }

    function getValue(filter) {
      return filter ? [filter.position, filter.alias].join('') : null;
    }
  });

  FilterPropsContainer.displayName = 'FilterPropsContainer';

  var FilterDetailsContainer = observer(
    React.createClass({
      shouldComponentUpdate: function(nextProps) {
        return nextProps.querySourceFieldId !== this.props.querySourceFieldId;
      },

      render: function() {
        var props = this.props;
        var valManager = props.validation;
        var propConfig = FilterPropertiesSchema(
          this,
          props.reportDesignerModel,
          props.fieldStore,
          props.reportFilter,
          valManager
        );

        isEmpty(props.alias) && removeUsedProps(propConfig);

        return <PropertiesEditorContainer propertyConfig={propConfig} />;

        function removeUsedProps(propConfig) {
          PropertiesEditorUtils.removeProps(propConfig, UNUSED_PROPS_NULL_CONFIG_FILTER);
        }
      }
    })
  );

  FilterDetailsContainer.displayName = 'FilterDetailsContainer';

  function setFilterConfig(props, seletedItem, newConfigField) {
    var reportFilter = props.reportFilter;
    reportFilter.setConfigModeToField && reportFilter.setConfigModeToField(newConfigField);
  }

  function getFilterList(props) {
    return function() {
      var reportFilter = props.reportFilter;
      return getOr([], 'filterFields', reportFilter);
    };
  }

  function getConfigFilter(props) {
    return function() {
      var reportFilter = props.reportFilter;
      return getOr(null, 'configField', reportFilter);
    };
  }

  module.exports = connect(
    setPropTypes({
      reportDesignerModel: React.PropTypes.object.isRequired,
      fieldStore: React.PropTypes.object.isRequired
    }),
    withProps(function(props) {
      var reportFilter = getOr({}, 'reportFields.reportFilter', props.reportDesignerModel);
      var configFilter = reportFilter.configField;

      return {
        reportFilter: reportFilter
      };
    }),

    withHandlers({
      setFilterConfig: curry(setFilterConfig),
      getFilterList: curry(getFilterList),
      getConfigFilter: curry(getConfigFilter)
    })
  )(FilterPropsContainer);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.FilterPropsContainer.jsx